/** These are published public store offers, never checkout-demo drafts. */
export type PublicFlyer = {
  merchantSlug: string;
  title: string;
  url: string;
  type: string;
  startsOn: string;
  endsOn: string;
  zipcode?: string;
  storeName?: string;
  createdAt?: string;
  sponsored?: boolean;
};

export const ALL_FLYERS_PATH = '/specials';
export const CASH_SAVER_SHELFIE: PublicFlyer = {
  merchantSlug: 'whitehaven-cash-saver',
  title: 'Cash Saver Whitehaven: featured grocery finds',
  url: '/flyers/cash-saver-whitehaven-shelfie',
  type: 'image/webp',
  startsOn: '2026-10-22',
  endsOn: '2026-11-04',
  zipcode: '38116',
  storeName: 'Cash Saver Whitehaven',
  createdAt: '2026-10-22T12:00:00Z',
  sponsored: false,
};

export const CASH_SAVER_IMAGE = '/partner-flyers/cash-saver-whitehaven-shelfie-2026-10-22.webp';
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
export function chicagoDate(date: Date = new Date()): string {
  return new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'America/Chicago',
  }).format(date);
}
export function flyerId(flyer: PublicFlyer): string {
  return [flyer.merchantSlug, flyer.startsOn, flyer.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0,55)].join('-');
}
export function flyerImage(flyer: PublicFlyer): string | null {
  if (flyer.url === CASH_SAVER_SHELFIE.url) return CASH_SAVER_IMAGE;
  return /^image\/(?:jpe?g|png|webp)$/i.test(flyer.type) ? flyer.url : null;
}
export function flyerHref(flyer: PublicFlyer): string {
  return flyer.url === CASH_SAVER_SHELFIE.url
    ? flyer.url : ALL_FLYERS_PATH + '?flyer=' + encodeURIComponent(flyerId(flyer));
}
export function selectCurrentFlyers(
  published: PublicFlyer[],
  today: string,
  zipcode?: string | null,
): PublicFlyer[] {
  if (!DATE_PATTERN.test(today)) return [];
  const validZip = typeof zipcode === 'string' && /^\d{5}$/.test(zipcode) ? zipcode : null;
  // Without a ZIP, don't claim any featured offer is "near you".
  if (!validZip) return [];
  const seen = new Set<string>();
  return [CASH_SAVER_SHELFIE, ...published].filter(flyer => {
    if (!flyer || !DATE_PATTERN.test(flyer.startsOn) || !DATE_PATTERN.test(flyer.endsOn) ||
      flyer.startsOn > today || flyer.endsOn < today) return false;
    const offerZip = flyer.zipcode || (flyer.merchantSlug === 'whitehaven-cash-saver' ? '38116' : '');
    if (!/^\d{5}$/.test(offerZip)) return false;
    // The pilot has market coverage within Memphis 381xx; other stores use exact ZIP.
    if (offerZip !== validZip && !(offerZip.startsWith('381') && validZip.startsWith('381'))) return false;
    const key = flyer.url; // allow multiple distinct flyers from one store.
    if (seen.has(key)) return false;
    seen.add(key); return true;
  }).sort((a,b) => {
    // A newly generated published flyer must beat an older fallback flyer.
    const aTime = Date.parse(a.createdAt || a.startsOn + 'T00:00:00Z') || 0;
    const bTime = Date.parse(b.createdAt || b.startsOn + 'T00:00:00Z') || 0;
    return bTime - aTime || b.startsOn.localeCompare(a.startsOn) || a.title.localeCompare(b.title);
  });
}
